export type CtaType = 'contact_cta' | 'app_download' | 'app_store' | 'google_play' | 'form_submit';

// tracks CTA click events for Amplitude
export const trackCtaClick = (ctaText: string, ctaType: CtaType): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'amplitude_event',
    event_name: 'cta_clicked',
    event_properties: {
      cta_text: ctaText,
      cta_type: ctaType,
      path: window.location.pathname,
    },
  });
};
